import React, { useState, useEffect, useContext } from "react";
import { Row, Col, Button, Modal, Form } from "react-bootstrap";
import ModalInputText from "./ModalInputText";
import { Store } from "react-notifications-component";
import PermissionContext from "../../../Store/permission-context";

const EditInventoryModal = (props) => {
  const [ShowModal, setShowModal] = useState(props.show);
  const [Itemname, setItemname] = useState(props.Invrec.Itemname);

  const [Unit, setUnit] = useState(props.Invrec.UnitLeft);
  const [CostPrice, setCostPrice] = useState(props.Invrec.CostPrice);

  const [USP1, setUSP1] = useState(props.Invrec.USP1);
  const [USP2, setUSP2] = useState(props.Invrec.USP2);
  const [USP3, setUSP3] = useState(props.Invrec.USP3);

  const [ErrorUP1, setErrorUP1] = useState(false);
  const [ErrorUP2, setErrorUP2] = useState(false);
  const [ErrorUP3, setErrorUP3] = useState(false);
  const [checkup, setcheckup] = useState(false);
  const PCtx = useContext(PermissionContext);
  let errorbackground = {
    backgroundColor: "#f04e00",
    fontFamily: "Times New Roman",
  };
  let successbackground = {
    backgroundColor: "#00ca65",
    fontFamily: "Times New Roman",
  };
  const [errorBackStyle, seterrorBackStyle] = useState(errorbackground);
  const [successBackStyle, setsuccessBackStyle] = useState(successbackground);

  const cancelM = () => {
    setShowModal(false);
    props.cancelModal();
  };

  useEffect(() => {
    let cp = Math.floor(parseFloat(CostPrice));
    if (parseFloat(USP1) >= 0 && USP1 < cp) {
      setErrorUP1(true);
      PCtx.displayAlert(
        "Selling Price Error",
        "The Unit Selling Price 1 should not be less than Unit Cost Price. Check the value(s) highlighted in Red",
        "danger"
      );
    } else {
      setErrorUP1(false);
    }

    if (parseFloat(USP2) >= 0 && USP2 < cp) {
      setErrorUP2(true);
      PCtx.displayAlert(
        "Selling Price Error",
        "The Unit Selling Price 2 should not be less than Unit Cost Price. Check the value(s) highlighted in Red",
        "danger"
      );
    } else {
      setErrorUP2(false);
    }
    if (parseFloat(USP3) >= 0 && parseFloat(USP3) < cp) {
      setErrorUP3(true);
      PCtx.displayAlert(
        "Selling Price Error",
        "The Unit Selling Price 3 should not be less than Unit Cost Price. Check the value(s) highlighted in Red",
        "danger"
      );
    } else {
      setErrorUP3(false);
    }
  }, [checkup]);

  const CheckUnitPrice = () => {
    setcheckup(!checkup);
  };

  const saveTheRecord = (e) => {
    e.preventDefault();
    if (ErrorUP1 || ErrorUP2 || ErrorUP3) {
      PCtx.displayAlert(
        "ERROR IN SAVING",
        Itemname +
          " properties cannot be saved. Please check the value(s) highlighted in Red.",
        "danger"
      );
    } else {
      let NewRecord = {
        GID: props.Invrec.GID,
        Itemname: props.Invrec.Itemname,
        SoldIn: props.Invrec.SoldIn,
        Unit: Unit,
        Costprice: CostPrice,

        USP1: USP1,
        USP2: USP2,
        USP3: USP3,
      };

      props.SaveNewRecord(NewRecord);
    }
  };

  const thisChange = (e) => {
    let stt = e.target.name;
    let val = e.target.value;
    if (!isNaN(val)) {
      switch (stt) {
        case "Unit":
          setUnit(val);
          break;
        case "CostPrice":
          setCostPrice(val);
          break;

        case "USP1":
          setUSP1(val);
          break;
        case "USP2":
          setUSP2(val);
          break;
        case "USP3":
          setUSP3(val);
          break;
      }
    }
  };

  return (
    ShowModal && (
      <Modal
        show={ShowModal}
        onHide={cancelM}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header style={successBackStyle} closeButton>
          <Modal.Title>{props.Invrec.Itemname}</Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{
            fontFamily: "Times New Roman",
          }}
        >
          <Form onSubmit={saveTheRecord}>
            <Row className="justify-content-around">
              <Col md={6} sm={6} xs={6}>
                <ModalInputText
                  Label="Unit Left"
                  Name="Unit"
                  Val={Unit}
                  thischange={thisChange}
                />
              </Col>
              <Col md={6} sm={6} xs={6}>
                <ModalInputText
                  Label="Cost Left"
                  Name="CostPrice"
                  Val={CostPrice}
                  thischange={thisChange}
                />
              </Col>

              <Col md={4} sm={4} xs={4}>
                <ModalInputText
                  Label="Unit S.Price 1"
                  Name="USP1"
                  Val={USP1}
                  thischange={thisChange}
                  theAction={CheckUnitPrice}
                  error={ErrorUP1}
                />
              </Col>

              <Col md={4} sm={4} xs={4}>
                <ModalInputText
                  Label="Unit S.Price 2"
                  Name="USP2"
                  Val={USP2}
                  thischange={thisChange}
                  theAction={CheckUnitPrice}
                  error={ErrorUP2}
                />
              </Col>
              <Col md={4} sm={4} xs={4}>
                <ModalInputText
                  Label="Unit S.Price 3"
                  Name="USP3"
                  Val={USP3}
                  thischange={thisChange}
                  theAction={CheckUnitPrice}
                  error={ErrorUP3}
                />
              </Col>
            </Row>
            <Row>
              <Col md={4} sm={4} xs={4}>
                <Button variant="outline-danger" onClick={cancelM}>
                  Cancel
                </Button>
              </Col>
              <Col md={4} sm={4} xs={4}>
                <Button variant="outline-success" type="submit">
                  Save
                </Button>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>
    )
  );
};

export default EditInventoryModal;
